import React, { Component } from 'react';
import {
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CBadge,
    CSpinner,
    CRow,
    CCol,
    CFormInput,
    CFormSelect,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'
import {
    cilPencil,
    cilSearch,
    cilPlus,
    cilLink,
    cilBan,
    cilCheck,
    cilLockLocked
} from '@coreui/icons'
import TableActions from '../../components/TableActions'
import AppButton from 'src/components/AppButton'
import PageHeader from 'src/components/PageHeader'
import ServerConnector from 'src/ServerConnector'
import { replaceEmpty } from 'src/util/StringUtil';
import MultiSelectionCheckbox from 'src/components/MultiSelectionCheckbox';
import { random } from 'src/util/MathUtil';

class ManageMentors extends Component {
    constructor(props) {
        super(props);

        this.state = {
            spinner: true,
            mentor_list: [],
            search_str: "",
            selected_role: "",
            popupselectedsubject_seq: -1,
            popupselectedtopic_seq: -1,
            popupsubject_list: [],
            popuptopic_list: [],
            linksubjectpopup: {
                data: [],
                visible: false,
                selected_mentor_seq: -1,
                selected_mentor_name: "",
                removeLoadingSeq: -1,
                addButtonLoading: false,
                randomNum: "1"
            },
            passwordpopup: {
                new_password: "",
                new_passworderr: "",
                confirmpassword: "",
                confirmpassworderr: "",
                visible: false,
                selected_mentor_seq: -1,
                selected_mentor_name: "",
                isLoadingSubmit: false
            }
        };
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        this.setState({
            spinner: true
        });
        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_MENTORS"
        }

        if (this.state.search_str.length != 0) {
            dataMap["search_str"] = this.state.search_str;
        }

        if (this.state.selected_role.length != 0) {
            dataMap["filter_role"] = this.state.selected_role;
        }

        connector.postData(dataMap, (data) => { // success
            this.setState({
                spinner: false,
                mentor_list: data.data
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                spinner: false,
                mentor_list: []
            });
        });
    }

    confirmStatusChange(user_seq, action) {

        var msg = "Do you want to deactivate this mentor?";
        if (action == "REACTIVATION") {
            msg = "Do you want to activate this mentor?";
        }

        this.props.showConfirmation(
            "Confirmation",
            msg,
            "Yes",
            "No",
            null,
            () => { this.statusChange(user_seq, action) }
        )
    }

    statusChange(user_seq, action) {

        this.props.showPageSpinner(true);

        var newStatus = "INACTIVE";
        if (action == "REACTIVATION") {
            newStatus = "ACTIVE";
        }

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "SET_MENTOR_STATUS",
            "user_seq": user_seq,
            "status": newStatus
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                this.loadData()
            });
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    updateSearchInput(event) {

        this.setState({
            search_str: event.target.value
        });
    }

    onRoleSelection(event) {

        this.setState({
            selected_role: event.target.value
        });
    }

    getLinkSubjectPopup(user_seq, mentor_name) {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_MENTOR_SUBJECTS",
            "user_seq": user_seq
        }
        connector.postData(dataMap, (data) => { // success

            this.loadAllSubjectsForSelection(data.data, user_seq, mentor_name);

        }, (err_id, msg, data) => { // failure

            if (err_id == "UE039") {

                this.loadAllSubjectsForSelection([], user_seq, mentor_name);
            }
            else {

                this.props.showPageSpinner(false);
                this.props.showAlert("Error", msg, "Ok", null, null);
            }
        });
    }

    loadAllSubjectsForSelection(mentorSubjects, user_seq, mentor_name) {

        let linksubjectpopup = this.state.linksubjectpopup;
        linksubjectpopup.selected_mentor_seq = user_seq;
        linksubjectpopup.selected_mentor_name = mentor_name;
        linksubjectpopup.visible = false;

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_SUBJECTS"
        }
        connector.postData(dataMap, (data) => { // success

            let list = [];
            for (var i = 0; i < data.data.length; i++) {

                if (data.data[i].status == "ACTIVE") {

                    list[i] = {
                        text: data.data[i].subject_name,
                        subjectSeq: data.data[i].subject_seq,
                        subList: []
                    }
                }
            }

            linksubjectpopup.data = list;

            this.setState({
                linksubjectpopup: linksubjectpopup
            }, () => {
                this.loadTopiForSubjects(mentorSubjects);
            });

        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        });
    }

    loadTopiForSubjects(mentorSubjects) {

        var linksubjectpopup = this.state.linksubjectpopup;

        if (linksubjectpopup.data.length != 0) {
            this.multiLoadTopics(0, linksubjectpopup, mentorSubjects);
        }

        // for (var dataIndex=0;dataIndex<linksubjectpopup.data.length;dataIndex++) {

        //     let selectedIndex = dataIndex;
        //     let connector = new ServerConnector();
        //     let dataMap = {
        //         _action_code: "GET_ALL_TOPICS",
        //         subject_seq: linksubjectpopup.data[dataIndex].subjectSeq
        //     }
        //     connector.postData(dataMap, (data) => { // success
    
        //         let subList = [];
        //         var isAllChecked = true;
        //         if (data.data.length == 0) {
        //             isAllChecked = false;
        //         }
        //         for (var i = 0; i < data.data.length; i++) {
    
        //             if (data.data[i].status == "ACTIVE") {

        //                 let mentorSubSeq = this.getMentorTopicSeq(
        //                     linksubjectpopup.data[selectedIndex].subjectSeq, 
        //                     data.data[i].topic_seq,
        //                     mentorSubjects
        //                 );

        //                 if (mentorSubSeq == -1) {

        //                     isAllChecked = false;
        //                 }

        //                 subList[i] = {
        //                     text: data.data[i].topic_name,
        //                     topicSeq: data.data[i].topic_seq,
        //                     mentorSubSeq: mentorSubSeq,
        //                     checked: mentorSubSeq != -1
        //                 }
        //             }
        //         }

        //         linksubjectpopup.data[selectedIndex].subList = subList;
        //         linksubjectpopup.data[selectedIndex].allChecked = isAllChecked;

        //         if (selectedIndex == linksubjectpopup.data.length - 1) {
                    
        //             linksubjectpopup.visible = true;
        //             linksubjectpopup.randomNum = random(100, 999);
        //             this.props.showPageSpinner(false);
        //         }

        //         this.setState({
        //             linksubjectpopup: linksubjectpopup
        //         });
        //     }, (err_cd, msg, data) => { // failure
        //         this.props.showPageSpinner(false);
        //     })
        // }
    }

    multiLoadTopics(dataIndex, linksubjectpopup, mentorSubjects) {

        let selectedIndex = dataIndex;
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_TOPICS",
            subject_seq: linksubjectpopup.data[dataIndex].subjectSeq
        }
        connector.postData(dataMap, (data) => { // success

            let subList = [];
            var isAllChecked = true;
            if (data.data.length == 0) {
                isAllChecked = false;
            }
            for (var i = 0; i < data.data.length; i++) {

                if (data.data[i].status == "ACTIVE") {

                    let mentorSubSeq = this.getMentorTopicSeq(
                        linksubjectpopup.data[selectedIndex].subjectSeq, 
                        data.data[i].topic_seq,
                        mentorSubjects
                    );

                    if (mentorSubSeq == -1) {

                        isAllChecked = false;
                    }

                    subList[i] = {
                        text: data.data[i].topic_name,
                        topicSeq: data.data[i].topic_seq,
                        mentorSubSeq: mentorSubSeq,
                        checked: mentorSubSeq != -1
                    }
                }
            }

            linksubjectpopup.data[selectedIndex].subList = subList;
            linksubjectpopup.data[selectedIndex].allChecked = isAllChecked;

            if (selectedIndex == linksubjectpopup.data.length - 1) {
                
                linksubjectpopup.visible = true;
                linksubjectpopup.randomNum = random(100, 999);
            }

            this.setState({
                linksubjectpopup: linksubjectpopup
            }, () => {
                if (selectedIndex < linksubjectpopup.data.length - 1) {
                    this.multiLoadTopics(dataIndex+1, linksubjectpopup, mentorSubjects);
                }
                else if (selectedIndex == linksubjectpopup.data.length - 1) {
                    this.props.showPageSpinner(false);
                }
            });
        }, (err_cd, msg, data) => { // failure
            this.props.showPageSpinner(false);

            if (selectedIndex < linksubjectpopup.data.length - 1) {
                this.multiLoadTopics(dataIndex+1, linksubjectpopup, mentorSubjects);
            }
        });
    }

    getMentorTopicSeq(subjectSeq, topicSeq, mentorSubjects) {

        for (var i=0;i<mentorSubjects.length;i++) {

            if (mentorSubjects[i].subject_seq == subjectSeq) {

                if (mentorSubjects[i].topic_seq == topicSeq) {

                    return mentorSubjects[i].mentor_sub_seq;
                }
            }
        }

        return -1;
    }

    closeLinkSubjectPopup() {

        let linksubjectpopup = this.state.linksubjectpopup;
        linksubjectpopup["visible"] = false;
        this.setState({
            linksubjectpopup: linksubjectpopup
        });
    }

    onPopupSubjectSelected(event) {

        this.setState({
            popupselectedsubject_seq: event.target.value
        }, () => {

            this.loadTopicForPopup();
        });
    }

    onPopupTopicSelected(event) {

        this.setState({
            popupselectedtopic_seq: event.target.value
        });
    }

    loadSubjectForPopup() {

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_SUBJECTS"
        }
        connector.postData(dataMap, (data) => { // success

            let activeRecords = [];
            for (var i = 0; i < data.data.length; i++) {

                if (data.data[i].status == "ACTIVE") {
                    activeRecords[activeRecords.length] = data.data[i];
                }
            }
            this.setState({
                popupsubject_list: activeRecords
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                popupsubject_list: []
            });
        })
    }

    loadTopicForPopup() {

        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_TOPICS",
            subject_seq: this.state.popupselectedsubject_seq
        }
        connector.postData(dataMap, (data) => { // success

            let ignorSeqs = [];
            for (var i = 0; i < this.state.linksubjectpopup.data.length; i++) {
                ignorSeqs[ignorSeqs.length] = this.state.linksubjectpopup.data[i].topic_seq;
            }

            let activeRecords = [];
            for (var i = 0; i < data.data.length; i++) {

                if (data.data[i].status == "ACTIVE" && ignorSeqs.indexOf(data.data[i].topic_seq) == -1) {
                    activeRecords[activeRecords.length] = data.data[i];
                }
            }
            this.setState({
                popuptopic_list: activeRecords,
                popupselectedtopic_seq: -1
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                popuptopic_list: [],
                popupselectedtopic_seq: -1
            });
        })
    }

    addSubjectToMentor() {

        if (this.state.popupselectedsubject_seq <= 0) {

            this.props.showAlert("Alert", "Please select subject", "Ok", null, null);
        }
        else {

            let linksubjectpopup = this.state.linksubjectpopup;
            linksubjectpopup["addButtonLoading"] = true;
            this.setState({
                linksubjectpopup: linksubjectpopup
            });

            let connector = new ServerConnector();
            let dataMap = {
                _action_code: "ASSIGN_MENTOR_SUBJECT",
                subject_seq: this.state.popupselectedsubject_seq,
                user_seq: this.state.linksubjectpopup.selected_mentor_seq
            }

            if (this.state.popupselectedtopic_seq > 0) {
                dataMap["topic_seq"] = this.state.popupselectedtopic_seq;
            }

            connector.postData(dataMap, (data) => { // success

                linksubjectpopup = this.state.linksubjectpopup;
                linksubjectpopup["addButtonLoading"] = false;
                this.setState({
                    linksubjectpopup: linksubjectpopup,
                    popupselectedsubject_seq: -1
                }, () => {

                    this.getLinkSubjectPopup(
                        this.state.linksubjectpopup.selected_mentor_seq,
                        this.state.linksubjectpopup.selected_mentor_name
                    );
                });
            }, (err_cd, msg, data) => { // failure

                linksubjectpopup = this.state.linksubjectpopup;
                linksubjectpopup["addButtonLoading"] = false;
                this.setState({
                    linksubjectpopup: linksubjectpopup
                });

                this.props.showAlert("Error", msg, "Ok", null, null);
            });
        }
    }

    removeSubject(mentor_sub_seq) {

        let linksubjectpopup = this.state.linksubjectpopup;
        linksubjectpopup["removeLoadingSeq"] = mentor_sub_seq;
        this.setState({
            linksubjectpopup: linksubjectpopup
        });

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "DELETE_MENTOR_SUBJECT",
            user_seq: this.state.linksubjectpopup.selected_mentor_seq,
            mentor_sub_seq: mentor_sub_seq
        }
        connector.postData(dataMap, (data) => { // success

            linksubjectpopup = this.state.linksubjectpopup;
            linksubjectpopup["removeLoadingSeq"] = -1;
            this.setState({
                linksubjectpopup: linksubjectpopup
            }, () => {

                this.getLinkSubjectPopup(
                    this.state.linksubjectpopup.selected_mentor_seq,
                    this.state.linksubjectpopup.selected_mentor_name
                );
            });

        }, (err_cd, msg, data) => { // failure

            linksubjectpopup = this.state.linksubjectpopup;
            linksubjectpopup["removeLoadingSeq"] = -1;
            this.setState({
                linksubjectpopup: linksubjectpopup
            });
            this.props.showAlert("Error", msg, "Ok", null, null);
        });
    }

    getRandomNumber() {

        const min = 1;
        const max = 100;
        const rand = min + Math.random() * (max - min);
        return rand;
    }

    openPasswordPopup(user_seq, user_name) {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup["visible"] = true;
        passwordpopup["isLoadingSubmit"] = false;
        passwordpopup["new_password"] = "";
        passwordpopup["new_passworderr"] = "";
        passwordpopup["confirmpassword"] = "";
        passwordpopup["confirmpassworderr"] = "";
        passwordpopup["selected_mentor_seq"] = user_seq;
        passwordpopup["selected_mentor_name"] = user_name;

        this.setState({
            passwordpopup: passwordpopup
        });
    }

    closePasswordPopup() {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup["visible"] = false;
        passwordpopup["isLoadingSubmit"] = false;
        passwordpopup["new_password"] = "";
        passwordpopup["new_passworderr"] = "";
        passwordpopup["confirmpassword"] = "";
        passwordpopup["confirmpassworderr"] = "";
        this.setState({
            passwordpopup: passwordpopup
        });
    }

    updatePasswordInput(inputField, event) {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup[inputField] = event.target.value;
        passwordpopup[inputField + "err"] = "";
        this.setState({
            passwordpopup: passwordpopup
        });
    }

    validateUpdatePassword() {

        var isValid = true;
        let passwordpopup = this.state.passwordpopup;

        if (this.state.passwordpopup.new_password.length == 0) {

            passwordpopup["new_passworderr"] = "Required";
            isValid = false;
        }

        if (this.state.passwordpopup.confirmpassword.length == 0) {

            passwordpopup["confirmpassworderr"] = "Required";
            isValid = false;
        }

        if (isValid && this.state.passwordpopup.new_password != this.state.passwordpopup.confirmpassword) {

            passwordpopup["confirmpassworderr"] = "Confirm password is not matching with new password";
            isValid = false;
        }

        if (isValid) {

            this.submitUpdatePassword();
        }
        else {

            this.setState({
                passwordpopup: passwordpopup
            });
        }
    }

    submitUpdatePassword() {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup["isLoadingSubmit"] = true;
        this.setState({
            passwordpopup: passwordpopup
        });

        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "UPDATE_MENTOR_PASSWORD",
            user_seq: this.state.passwordpopup.selected_mentor_seq,
            new_password: this.state.passwordpopup.new_password
        }
        connector.postData(dataMap, (data) => { // success

            this.closePasswordPopup();
            this.props.showAlert("Success", data.msg, "Ok", null, null);

        }, (err_cd, msg, data) => { // failure

            var isHandled = false;
            passwordpopup["isLoadingSubmit"] = false;

            if (data.data) {

                for (let key in data.data) {

                    passwordpopup[key + "err"] = data.data[key];
                }
                isHandled = true;
            }

            this.setState({
                passwordpopup: passwordpopup
            });

            if (!isHandled) {

                this.props.showAlert("Error", msg, "Ok", null, null);
            }
        });
    }

    updateMentorTopics(objectArray, objectIndex) {

        if (objectIndex < 0 || objectIndex >= objectArray.length) {
            return;
        }

        var object = objectArray[objectIndex];

        let subjectSeq = object.item.subjectSeq;
        let topicSeq = object.item.subList[object.subIndex].topicSeq;
        let mentorSubSeq = object.item.subList[object.subIndex].mentorSubSeq;
        let isChecked = object.item.subList[object.subIndex].checked;

        if (isChecked) {

            let connector = new ServerConnector();
            let dataMap = {
                _action_code: "ASSIGN_MENTOR_SUBJECT",
                subject_seq: subjectSeq,
                user_seq: this.state.linksubjectpopup.selected_mentor_seq,
                topic_seq: topicSeq
            }

            connector.postData(dataMap, (data) => { // success

                this.updateMentorTopics(objectArray, objectIndex+1);

            }, (err_cd, msg, data) => { // failure

                this.props.showAlert("Error", msg, "Ok", null, null);
            });
        }
        else {

            let connector = new ServerConnector();
            let dataMap = {
                "_action_code": "DELETE_MENTOR_SUBJECT",
                user_seq: this.state.linksubjectpopup.selected_mentor_seq,
                subject_seq: subjectSeq,
                topic_seq: topicSeq
            }
            connector.postData(dataMap, (data) => { // success

                this.updateMentorTopics(objectArray, objectIndex+1);

            }, (err_cd, msg, data) => { // failure

                this.props.showAlert("Error", msg, "Ok", null, null);
            });
        }
    }

    render() {
        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Add Mentor"
                        icon={cilPlus}
                        isLoading={false}
                        onClick={() => this.props.navigate("add_mentor", { user_seq: -999 })} />
                </PageHeader>
                <CRow>
                    <CCol md="3">
                        <CFormSelect value={this.state.selected_role} onChange={(event) => { this.onRoleSelection(event) }}>
                            <option value="">Select Role</option>
                            <option value="MENTOR">MENTOR</option>
                            <option value="COORDINATOR">COORDINATOR</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md="3">
                        <CFormInput
                            type="text"
                            placeholder="Search"
                            onChange={(event) => { this.updateSearchInput(event) }}
                            value={this.state.search_str} />
                    </CCol>
                    <CCol md="6">
                        <AppButton
                            color="primary"
                            name="Search"
                            icon={cilSearch}
                            isLoading={false}
                            onClick={() => { this.loadData(); }} />
                    </CCol>
                </CRow>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell style={{width: '30%'}} scope="col">Name</CTableHeaderCell>
                            <CTableHeaderCell style={{width: '30%'}} scope="col">Email </CTableHeaderCell>
                            <CTableHeaderCell style={{width: '20%'}} scope="col">Role</CTableHeaderCell>
                            <CTableHeaderCell style={{width: '10%'}} scope="col">Status</CTableHeaderCell>
                            <CTableHeaderCell style={{width: '10%'}} scope="col">Actions</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {
                            this.state.mentor_list.map((object, index) => {
                                let menuList = [
                                    {
                                        name: "Edit",
                                        icon: cilPencil,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.props.navigate("add_mentor", { user_seq: object.user_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "View",
                                        icon: cilSearch,
                                        isLoading: false,
                                        visible: true,
                                        onClick: () => { this.props.navigate("view_mentor", { user_seq: object.user_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "Link Subject",
                                        icon: cilLink,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.getLinkSubjectPopup(object.user_seq, object.name) },
                                        data: null
                                    },
                                    {
                                        name: "Update Password",
                                        icon: cilLockLocked,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.openPasswordPopup(object.user_seq, object.name) },
                                        data: null
                                    },
                                    {
                                        name: "Deactivate",
                                        icon: cilBan,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.user_seq, "DEACTIVATION") },
                                        data: null
                                    },
                                    {
                                        name: "Activate",
                                        icon: cilCheck,
                                        isLoading: false,
                                        visible: object.status != "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.user_seq, "REACTIVATION") },
                                        data: null
                                    }
                                ];

                                return (
                                    <CTableRow key={String(object.user_seq)}>
                                        <CTableDataCell>{replaceEmpty(object.name)}</CTableDataCell>
                                        <CTableDataCell>{replaceEmpty(object.email)}</CTableDataCell>
                                        <CTableDataCell>{replaceEmpty(object.role)}</CTableDataCell>
                                        <CTableDataCell>
                                            <CBadge color={object.status == "ACTIVE" ? "primary" : "danger"} shape="rounded-pill" size="sm">{object.status}</CBadge>
                                        </CTableDataCell>
                                        <CTableDataCell>
                                            <TableActions
                                                key={String(object.user_seq) + object.status}
                                                actions={menuList}
                                                minCount="1" />
                                        </CTableDataCell>
                                    </CTableRow>
                                )
                            })
                        }
                        {
                            this.state.mentor_list.length == 0 ?
                                <CTableRow>
                                    <CTableDataCell colSpan={5} className="alignCenter">No Data Available</CTableDataCell>
                                </CTableRow>
                                :
                                null
                        }
                    </CTableBody>
                </CTable>

                <CModal
                    visible={this.state.linksubjectpopup.visible}
                    onClose={() => { this.closeLinkSubjectPopup() }} >
                    <CModalHeader>
                        <CModalTitle>Link Subject To {this.state.linksubjectpopup.selected_mentor_name}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>

                        <MultiSelectionCheckbox
                            key={"multiSelection" + this.state.linksubjectpopup.randomNum}
                            list={this.state.linksubjectpopup.data}
                            onUpdate={(objectArray) => {this.updateMentorTopics(objectArray, 0)}} />
                        {/* <CRow>
                            <CCol md="5">
                                <CFormSelect size="sm" value={this.state.popupselectedsubject_seq}
                                    onChange={(event) => { this.onPopupSubjectSelected(event) }}>
                                    <option value="-1">Select Subject</option>
                                    {
                                        this.state.popupsubject_list.map((object, index) => {
                                            return (
                                                <option key={String(object.subject_seq)} value={object.subject_seq}>{object.subject_name}</option>
                                            )
                                        })
                                    }
                                </CFormSelect>
                            </CCol>
                            <CCol md="5">
                                <CFormSelect size="sm" value={this.state.popupselectedtopic_seq}
                                    onChange={(event) => { this.onPopupTopicSelected(event) }}>
                                    <option value="-1">Select Topic</option>
                                    {
                                        this.state.popuptopic_list.map((object, index) => {
                                            return (
                                                <option key={String(object.topic_seq)} value={object.topic_seq}>{object.topic_name}</option>
                                            )
                                        })
                                    }
                                </CFormSelect>
                            </CCol>
                            <CCol md="2">
                                <AppButton
                                    size="xs"
                                    name="Add"
                                    color="primary"
                                    icon={cilPlus}
                                    isLoading={this.state.linksubjectpopup.addButtonLoading}
                                    isBoldFont={false}
                                    onClick={() => this.addSubjectToMentor()} />
                            </CCol>
                        </CRow> */}
                        {/* <CTable className="linkSubjectTable">
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">Subject Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Topic Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Actions</CTableHeaderCell>
                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {
                                    this.state.linksubjectpopup.data.map((object, index) => {
                                        let menuList = [
                                            {
                                                name: "Remove",
                                                icon: cilBan,
                                                isLoading: this.state.linksubjectpopup.removeLoadingSeq == object.mentor_sub_seq,
                                                visible: true,
                                                onClick: () => { this.removeSubject(object.mentor_sub_seq) },
                                                data: null
                                            },
                                        ];

                                        return (
                                            <CTableRow key={String(object.mentor_sub_seq)}>
                                                <CTableDataCell>{object.subject_name}</CTableDataCell>
                                                <CTableDataCell>{object.topic_name}</CTableDataCell>
                                                <CTableDataCell>
                                                    <TableActions
                                                        key={String(object.mentor_sub_seq) + String(this.getRandomNumber())}
                                                        actions={menuList}
                                                        minCount="1" />
                                                </CTableDataCell>
                                            </CTableRow>
                                        )
                                    })
                                }
                                {
                                    this.state.linksubjectpopup.data.length == 0 ?
                                        <CTableRow>
                                            <CTableDataCell colSpan={3} className="alignCenter">No Data Available</CTableDataCell>
                                        </CTableRow>
                                        :
                                        null
                                }
                            </CTableBody>
                        </CTable> */}
                    </CModalBody>
                </CModal>

                <CModal
                    visible={this.state.passwordpopup.visible}
                    onClose={() => { this.closePasswordPopup() }} >
                    <CModalHeader>
                        <CModalTitle>Update Password for {this.state.passwordpopup.selected_mentor_name}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <CRow>
                            <CCol md="12">
                                <CFormInput type="password" maxLength="64"
                                    onChange={(event) => { this.updatePasswordInput("new_password", event) }}
                                    value={this.state.passwordpopup.new_password}
                                    placeholder="Enter New Password" />
                                <div className="inputError">
                                    {this.state.passwordpopup.new_passworderr}
                                </div>
                            </CCol>
                            <CCol md="12" className="mt-3">
                                <CFormInput type="password" maxLength="64"
                                    onChange={(event) => { this.updatePasswordInput("confirmpassword", event) }}
                                    value={this.state.passwordpopup.confirmpassword}
                                    placeholder="Confirm Password" />
                                <div className="inputError">
                                    {this.state.passwordpopup.confirmpassworderr}
                                </div>
                            </CCol>
                        </CRow>
                    </CModalBody>
                    <CModalFooter>
                        <AppButton
                            size="sm"
                            name="Cancel"
                            isLoading={false}
                            onClick={() => { this.closePasswordPopup(); }} />
                        <AppButton
                            size="sm"
                            name="Submit"
                            color="primary"
                            isLoading={this.state.passwordpopup.isLoadingSubmit}
                            onClick={() => { this.validateUpdatePassword(); }} />
                    </CModalFooter>
                </CModal>
            </>
        );
    }
}

export default ManageMentors;